import styled from "styled-components";

import { RadioLabelText } from "@similarweb/ui-components";

import { RadioSelect } from "app/pages/sales-intelligence/common-components/form-fields";
import { StyledRadioContainer } from "app/pages/sales-intelligence/common-components/form-fields/components/RadioSelect/styles";

export const HorizontalRadioSelect = styled(RadioSelect)`
    align-items: center;
    display: flex;
    gap: 12px;

    ${StyledRadioContainer} {
        margin-right: 0;
    }

    ${RadioLabelText} {
        margin-left: ${({ size }) => (size === "sm" ? 4 : 8)}px;
    }
`;
